import React from "react";
import IntroModal from "../intro-modal/IntroModal";
import { SplashScreen } from "../../_metronic/_partials/controls";
import { shallowEqual } from "react-redux";
import { useSelector } from "react-redux";
import Demo1Dashboard from "../../_metronic/_partials/dashboards/Demo1Dashboard";

export function DashboardPage(props) {
  const { studioLoader } = useSelector((state) => state.studio, shallowEqual);
  return (
    <>
      {studioLoader ? (
        <SplashScreen />
      ) : (
        <>
          {props.studio.studioWall.show_intro_popup ? (
            <IntroModal wallID={props.match.params.wallId} />
          ) : null}
          <Demo1Dashboard {...props} />
        </>
      )}
    </>
  );
}
